"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Builder {
    constructor() { }
    /**
     *
     * @param data FormattedData[]
     * @returns Object[]
     */
    buildSummary(data) { }
    /**
     *
     * @param data FormattedData[]
     * @returns any[][]
     */
    buildDetailed(data) { }
    /**
     *
     * @param data Object
     * @returns any[][]
     */
    layout(data) { }
}
exports.default = Builder;
